import './About.css'

export default function About () {
  return <div class='About'>About</div>
}
